<template lang="pug">
div
  v-progress-linear(:value="progress")
  .pa-4
    .quiz.pa-3
      // @TODO v-html to render function
      // (here we have unrendered html from backend)
      h3(v-html="question.subtitle")
      p.pa-2(v-if="question.body", v-text="question.body")
      AnswerBlock(
        v-for="(answer_block, i) in question.answer_blocks",
        :key="i",
        :answer_block_data="answer_block"
      )
      v-btn(v-if="question.is_looped", color="primary", @click="addLoop")
        v-icon(left) mdi-plus
        span add
      v-card-actions
        v-btn(text, @click="goBack") 
          v-icon(left) mdi-step-backward
          span Back
        v-spacer
        v-btn(
          v-if="showNext",
          color="primary",
          :loading="isAnswering",
          @click="goNext"
        ) next
</template>

<script>
import { debounce } from "throttle-debounce";

const jobTitleKeys = [
  "Action",
  "Job title",
  "SOC group",
  "Tier 2 Qualified",
  "Skills level",
  "Salary new entrant",
  "Salary experienced worker",
  "On shortage occupation list",
];

const headerWithHelper = [
  "Skills level",
  "Salary new entrant",
  "Salary experienced worker",
  "On shortage occupation list",
];

const listOfAt = ["CreatedAt", "DeletedAt", "UpdatedAt", "id"];

export default {
  // components: {
  //   ModalHelper
  // },

  props: {
    questions: {
      type: [Array, Object],
      required: true,
    },

    step: {
      // old name: default_ind
      type: [String, Number],
      required: false,
      default: 1,
    },

    flowId: {
      type: [String, Number],
      required: false,
      default: 1,
    },

    caseId: {
      type: [String, Number],
      required: false,
      default: 1,
    },
  },

  data: () => ({
    menu: false,

    isAnswering: false,
    isSearchLoading: false,
    isModalHelper: false,
    disabled: false,

    inputs: [],
    search: "",
    helperColumnType: "",
    addLoopCount: 1,
    jobsList: [],
    autocompleteItems: [],

    currentQuestionIndex: null,
  }),

  methods: {
    addLoop() {
      this.question.answer_blocks.push(
        ...this.answerBlocks.answerBlocksTemplate
      );
      this.inputs.push(...new Array(this.answerBlocks.length).fill(""));
    },

    deleteLoop(i) {
      this.question.answer_blocks.splice(i, this.answerBlocks.length);
      this.inputs.splice(i, this.answerBlocks.length);
    },

    initQuiz() {
      this.setLoader();
      this.checkIsPrevious();
      this.currentQuestionIndex = this.step;
      this.refreshInputs();
    },

    refreshInputs() {
      this.inputs = new Array(this.question.answer_blocks.length).fill("");
    },

    onInputSearchTable(value) {
      this.axios.get(`/search/job_titles?q=${value}`).then((r) => {
        this.jobsList = r.data;
      });

      // @TODO move to throttle later
      //let searchFunc = debounce(300, false, () => {
      //  this.axios
      //    .get(`/search/job_titles?q=${value}`)
      //    .then(r => {
      //      this.jobsList = r.data
      //    })
      //})

      //searchFunc()
    },

    onChangeCheckbox(value, i) {
      let values = this.splitAnswers(this.inputs[i]);

      if (this.inputs[i].length > 0) {
        if (values && values.filter((v) => v === value).length > 0) {
          this.inputs[i] = values.filter((v) => v != value).join(",,");
        } else {
          values.push(value);
          this.inputs[i] = values.join(",,");
        }
      } else {
        this.inputs[i] = value;
      }
    },

    onInputAnswer(answer, i) {
      this.inputs[i] = answer.value;
    },

    onUpdateSearchInput() {
      let searchFunc = debounce(300, false, () => {
        this.isSearchLoading = true;

        this.axios
          .get(this.question.answer_blocks[0].values[0].url, {
            params: {
              q: encodeURIComponent(this.search),
            },
          })
          .then((resp) => {
            this.autocompleteItems = resp.data.items;
          })
          .finally(() => {
            this.isSearchLoading = false;
          });
      });

      searchFunc();
    },

    setJobTitle(item, i) {
      this.inputs[i] = item.id;
      this.completeAnswer();
    },

    goNext() {
      this.completeAnswer();
    },

    completeAnswer() {
      this.setLoader();

      const body = { answer_blocks: this.inputs.map((i) => ({ answer: i })) };

      if (this.caseId) body.case_id = this.caseId;
      this.isAnswering = true;
      this.axios
        .post(`/flows/answer/${this.flowId}`, body)
        .then((r) => {
          this.isAnswering = false;
          if (r.data.status === "passed") {
            this.finishQuiz();
          } else {
            this.savePrevious();
            this.currentQuestionIndex = r.data.step.index;
          }
          this.refreshInputs();
        })
        .catch(() => {
          this.$message.errorFromServer();
        });
      // @TODO catch and show normally (userfriendly)
    },

    goBack() {
      this.setLoader();

      if (this.previousQuestionIndex >= 0) {
        this.currentQuestionIndex = this.previousQuestionIndex;
      } else {
        this.$emit("starting");
      }
    },

    sendAnswer(answer) {
      this.setLoader();
      this.$emit("answer", answer);
    },

    finishQuiz() {
      this.setLoader();
      this.$emit("finish");
    },

    setLoader(payload = true) {
      this.$emit("loader", payload);

      setTimeout(() => {
        this.$nextTick(() => {
          this.$emit("loader", false);
        });
      }, 800);
    },

    savePrevious() {
      this.$emit("setMemory", {
        index: this.currentQuestionIndex,
        input: this.inputs,
      });
    },

    checkIsPrevious() {
      if (this.question && this.question.chachedValue) {
        this.inputs = this.question.chachedValue;
        this.disabled = true;
      }
    },

    // Modal-helper methods

    isHelperHeader(header) {
      return headerWithHelper.includes(header);
    },

    openHelper(header) {
      this.helperColumnType = header ?? "";
      this.isModalHelper = true;
    },

    closeModalHelper() {
      this.isModalHelper = false;
    },

    // Helpers

    isInclude(k) {
      return listOfAt.includes(k);
    },

    splitAnswers(items) {
      return items.split(",,");
    },

    dividerNeeded(i) {
      const length = this.answerBlocks.length;
      return length ? i !== 0 && i % length === 0 : false;
    },
  },

  computed: {
    question() {
      const question = this.questions.find(
        (item) => item.index === this.currentQuestionIndex
      );
      return question?.question ?? false;
    },

    previousQuestionIndex() {
      let currentPosition = this.questions.findIndex(
        (item) => item.index === this.currentQuestionIndex
      );

      if (!currentPosition) return -1;

      let previosIndex = currentPosition - 1;

      if (previosIndex >= 0) {
        let previousElement = this.questions.find((e, i) => i === previosIndex);

        if (!previousElement) return -1;

        if (
          previousElement.index >= this.step &&
          previousElement.chachedValue
        ) {
          return previousElement.index;
        } else {
          return -1;
        }
      }

      return -1; // Show starting window here
    },

    showNext() {
      return true;
    },

    jobTitleKeys() {
      return jobTitleKeys;
    },

    questionsAnswerBlocksLengths() {
      return this.$store.state.questionsAnswerBlocksLengths;
    },

    answerBlocks() {
      return (
        this.questionsAnswerBlocksLengths.find(
          (item) => item.ID === this.question.ID
        ) ?? null
      );
    },
  },

  // @TODO rework watchers to hooks
  watch: {
    currentQuestionIndex(nV, oV) {
      if (nV !== oV) return;
      this.setLoader();
      this.sendAnswer(nV);
    },
  },

  created() {
    this.updateQuestionsAnswerBlocksLengths();
  },

  mounted() {
    this.initQuiz();
  },
};
</script>

<style lang="scss" scoped>
.ra-table-th-helper {
  padding: 8px;

  border-radius: 50px;

  color: red;
  background-color: transparent;
  font-size: 17px;

  cursor: pointer;

  &:hover {
    filter: hue-rotate(100deg);
  }
}
</style>
